import React from 'react';
var Option = function (_a) {
    var value = _a.value, children = _a.children, selected = _a.selected, disabled = _a.disabled, hidden = _a.hidden;
    return (React.createElement("option", { value: value, selected: selected, disabled: disabled, hidden: hidden }, children));
};
export default Option;
